import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useUpdateSiteControllerSettingTemairazu } from "../../../../model/temairazu/use-case";

import type { SiteControllerSettingTemairazuFormModel } from "../../../../model/temairazu/type";

type Props = {
	viewModel: SiteControllerSettingTemairazuFormModel["ViewModel"]; //
	onResetViewModel: () => void;
};

export const useSettingsSiteControllerTemairazu = ({ viewModel, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useUpdateSiteControllerSettingTemairazu({ viewModel });
	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdate().finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "サイコン設定（手間いらず）を更新しました",
			});
			onResetViewModel();
		}
	}, [_onUpdate, hideLoadingScreenCallback, onResetViewModel, showLoadingScreenCallback]);

	return {
		onUpdate,
	};
};
